"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var ActionTypes = _interopRequireWildcard(require("MeetingsLib/redux/actions/ActionTypes"));

var initialState = new _Branding.default();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, (0, _fluxActions.combineActions)(ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED), function (state, action) {
  if (action.payload && action.payload.branding && action.payload.branding.primaryColor !== null) {
    var _action$payload$brand = action.payload.branding,
        primaryColor = _action$payload$brand.primaryColor,
        logoUrl = _action$payload$brand.logoUrl,
        logoAltText = _action$payload$brand.logoAltText,
        companyName = _action$payload$brand.companyName;
    return state.set('primaryColor', primaryColor).set('logoUrl', logoUrl).set('logoAltText', logoAltText).set('companyName', companyName);
  }

  return state;
}), initialState);

exports.default = _default;
module.exports = exports.default;